export default __webpack_public_path__ + "static/media/home.0c5e0cee.svg";